import addError from '../../../utils/error.jsx';

export function request() {
    return {
        type: 'GET_LEGS_RUM'
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'ERROR_LEGS_RUM',
        errors
    };
}

export function finish(legs) {
    return {
        type: 'FINISH_LEGS_RUM',
        legs
    };
}
